import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../../api/analytics';
import { queryKeys } from '../queryClient';

export function useRevenue(from: string, to: string) {
  return useQuery({ queryKey: queryKeys.analytics('revenue', from, to), queryFn: () => analyticsApi.revenue(from, to) });
}

export function useJobsMetrics(from: string, to: string) {
  return useQuery({ queryKey: queryKeys.analytics('jobs', from, to), queryFn: () => analyticsApi.jobs(from, to) });
}

export function useWorkerMetrics(from: string, to: string) {
  return useQuery({ queryKey: queryKeys.analytics('workers', from, to), queryFn: () => analyticsApi.workers(from, to) });
}

export function useDemand(from: string, to: string) {
  return useQuery({ queryKey: queryKeys.analytics('demand', from, to), queryFn: () => analyticsApi.demand(from, to) });
}
